import { titleCase } from './SqliteHelp.js'
export function makeRoutesCode(dbName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));
    let routesCode_ = ""
    let pathsCode_ = ""
    tableNames.forEach((tableName) => {
        routesCode_ = routesCode_ + `
  static const ${tableName.toUpperCase()} = _Paths.${tableName.toUpperCase()};`
        pathsCode_ = pathsCode_ + `
  static const ${tableName.toUpperCase()} = '/${tableName}';`
    });
    return `/// Author: Samle
part of 'app_pages.dart';
// DO NOT EDIT. This is code generated via package:get_cli/get_cli.dart

abstract class Routes {
  Routes._();${routesCode_}
}

abstract class _Paths {
  _Paths._();${pathsCode_}
}
`
}